import { isMapPath } from './mapParamsState';

// /map never carries a query string. Anything arriving on it is discarded: removed from the
// address bar before analytics initializes, so nothing reaches history or the GA page_view.
if (typeof window !== 'undefined' && isMapPath(window.location.pathname) && window.location.search) {
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.hash);
}
